import * as React from "react";
import HubspotContactForm from "components/modules/HubspotGeneralForm";
import { Dialog } from "@hubble/web";

type Props = {
  modalOpen: boolean;
  closeModal: () => void;
  formId: string;
  modalTitle?: string;
  modalSubtitle?: string;
};

const InstitutionsHubspotModal: React.FC<Props> = ({
  modalOpen,
  closeModal,
  formId,
  modalTitle,
  modalSubtitle
}) => {
  return (
    <Dialog
      open={modalOpen}
      onOpenChange={(open) => {
        if (!open) {
          closeModal();
        }
      }}
      testId={"institutions"}
    >
      <Dialog.Container className="institutions-modal">
        <Dialog.Header>
          {modalTitle && <Dialog.Title>{modalTitle}</Dialog.Title>}
          {modalSubtitle && (
            <Dialog.Description>{modalSubtitle}</Dialog.Description>
          )}
        </Dialog.Header>
        <Dialog.Content>
          <HubspotContactForm formId={formId} />
        </Dialog.Content>
      </Dialog.Container>
    </Dialog>
  );
};

export default InstitutionsHubspotModal;
